class LangSelector extends HHBaseElement {
  constructor() {
    super();

    this.submitButton = this.querySelector(".js-submit-localization")
    this.countrySelector = this.querySelector(".js-country-selector")
    this.languageSelector = this.querySelector(".js-language-selector")
    this.form = this.querySelector("form")
    this.langHiddenInput = this.querySelector(".js-lang")

    this.submitButton.addEventListener("click", this.submit.bind(this))
    document.addEventListener('countryChanged', this.toggleLangSelector.bind(this))
    this.toggleLangSelector()
    this.initializeLanguageCombobox()
  }

  onItemClick(event) {
    event.preventDefault();
    const lang = this.querySelector(".js-lang")
    const form = this.querySelector('form');
    lang.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  initializeLanguageCombobox() {
    const languageCombobox = this.languageSelector.querySelector('[role="combobox"]');
    const currentSelectedOption = this.languageSelector.querySelector('[aria-selected="true"]:not(.hidden)');

    if (languageCombobox && currentSelectedOption) {
      languageCombobox.innerHTML = currentSelectedOption.innerHTML;
    }
  }

  toggleLangSelector() {
    const countryOption = this.countrySelector.querySelector('[aria-selected="true"]');
    const country = countryOption?.innerText;
    const languages = (countryOption?.dataset?.languages || 'en').split(',').map(lang => lang.trim().toLowerCase());

    this.languageSelector.querySelectorAll('[role="option"]').forEach(option => {
      const langValue = option.dataset.value.toLowerCase();
      if (languages.includes(langValue)) {
        option.classList.remove("hidden");
      } else {
        option.classList.add("hidden");
      }
    });

    // Always select the first available language for the new country
    const visibleOptions = this.languageSelector.querySelectorAll('[role="option"]:not(.hidden)');

    if (visibleOptions.length > 0) {
      // Remove current selection from all options
      this.languageSelector.querySelectorAll('[role="option"]').forEach(opt => {
        opt.setAttribute('aria-selected', 'false');
        opt.classList.remove('option-current');
      });

      // Set first visible option as selected
      visibleOptions[0].setAttribute('aria-selected', 'true');
      visibleOptions[0].classList.add('option-current');

      // Update the combobox display text to show the selected language
      const languageCombobox = this.languageSelector.querySelector('[role="combobox"]');
      if (languageCombobox) {
        languageCombobox.innerHTML = visibleOptions[0].innerHTML;
      }

      // Update hidden input
      if (this.langHiddenInput) {
        this.langHiddenInput.value = visibleOptions[0].dataset.value;
      }
    }

    if (country === "US" || country === "United States") {
      this.languageSelector.classList.add("hidden")
    } else {
      this.languageSelector.classList.remove("hidden")
    }
  }

  submit() {
    const countryUrl = this.countrySelector.querySelector('[aria-selected="true"]')?.dataset?.href
    const lang = this.form.querySelector('[aria-selected="true"]')?.dataset.value || 'en'

    window.location.href = `${countryUrl.replace('en-', `${lang}-`)}`;
  }
}

window.customElements.define('lang-selector', LangSelector);
